export function getView(person) {
  return person.gender && !person.is_external_professional
}
